export default "__VITE_ASSET__DtHvF2Wv__"